import { DefaultValidator } from '..'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.validVehiclePlate'

export const validVehiclePlate = value =>
  /^[\s]*((AG|AI|AR|BE|BL|BS|FR|GE|GL|GR|JU|LU|NE|NW|OW|SG|SH|SO|SZ|TG|TI|UR|VD|VS|ZG|ZH|FL){1}[\s-_]*[0-9]{1,7}[\s-_]*[A-Z]{0,2})[\s]*$/i.test(
    String(value),
  )

export const validVehiclePlateTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validVehiclePlate, localeKey || defaultTranslateKey),
)
